import { useAtomValue, useSetAtom } from "jotai";
import { AddTextIcon } from "@/icons/widget-menu";
import { widgetMenuOptionsAtom, widgetMenuOptionsByNameAtom } from "@/interface/AppStore";
import type { MenuOptionResult, SetActiveSubMenu } from "../../types";
import { applyValue } from "../applyValue";
import { setNewOptions } from "../setNewOptions";

interface UseAddTextButtonProps {
    setActiveSubMenu: SetActiveSubMenu;
}

export function useAddTextButton({ setActiveSubMenu }: UseAddTextButtonProps): MenuOptionResult {
    const options = useAtomValue(widgetMenuOptionsByNameAtom("addText"));
    const setWidgetMenuOptions = useSetAtom(widgetMenuOptionsAtom);

    const handleClick = () => {
        setActiveSubMenu(null);

        const setAddTextOptions = setNewOptions({ name: "addText", setWidgetMenuOptions });

        applyValue({ options, value: "", setNewOptions: setAddTextOptions });
    };

    return {
        content: <AddTextIcon />,
        handleClick,
    };
}
